import * as types from "./types";

const INITIAL_STATE = {
  editRequest: null,
  loading: false,
  submitting: false,
  error: null,
};

const companyEditRequest = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_COMPANY_EDIT_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_COMPANY_EDIT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        editRequest: action.payload,
      };
    case types.GET_COMPANY_EDIT_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload?.error || null,
      };

    case types.CREATE_COMPANY_EDIT_REQUEST_REQUEST:
    case types.UPDATE_COMPANY_EDIT_REQUEST_REQUEST:
    case types.DELETE_COMPANY_EDIT_REQUEST_REQUEST:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case types.CREATE_COMPANY_EDIT_REQUEST_SUCCESS:
    case types.UPDATE_COMPANY_EDIT_REQUEST_SUCCESS:
      return {
        ...state,
        submitting: false,
        editRequest: action.payload,
      };

    case types.DELETE_COMPANY_EDIT_REQUEST_SUCCESS:
      return {
        ...state,
        submitting: false,
        editRequest: null,
      };

    case types.CREATE_COMPANY_EDIT_REQUEST_FAILURE:
    case types.UPDATE_COMPANY_EDIT_REQUEST_FAILURE:
    case types.DELETE_COMPANY_EDIT_REQUEST_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload?.error || null,
      };

    case types.CLEAR_COMPANY_EDIT_REQUEST:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default companyEditRequest;
